import { simulationAddressSelector } from '@/checkout-instore-legacy/cart/simulation/selectors'
import {
  GetShowTogetherProductsInput,
  ShowTogetherItem,
  SimulationParams,
} from '@/checkout-instore-legacy/product/typings'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import { usingMultiSeller } from '@/checkout-instore-legacy/seller/utils'
import { getAccountName } from '@/checkout-instore-legacy/utils/UrlUtils'
import getSalesChannel from '@/checkout-instore-legacy/utils/getSalesChannel'
import { waitForSessionData } from '@/checkout-instore-legacy/utils/sessionUtils'
import { getSimulationParams } from '@/checkout-instore-legacy/utils/simulationUtils'

export const normalizePrice = (price: number | null) => (price ?? 0) / 100

export const getPriceInfo = (item: ShowTogetherItem) => {
  const purchaseConditionPrice = item.purchaseCondition?.find(
    (purchaseConditionsPrice) => purchaseConditionsPrice.id === item.id
  )

  let currentPrice = purchaseConditionPrice?.price

  if (item.manualPrice) {
    currentPrice = item.manualPrice
  }

  const shouldShowListPrice =
    purchaseConditionPrice && purchaseConditionPrice.listPrice !== currentPrice

  return {
    price: currentPrice,
    listPrice: purchaseConditionPrice?.listPrice,
    shouldShowListPrice,
  }
}

export const getSimulationsParams = async (): Promise<SimulationParams> => {
  const simulationAddress = simulationAddressSelector(
    getReduxStore()?.getState()
  )
  const sessionData = await waitForSessionData()
  const simulationParams: any = getSimulationParams(
    undefined,
    sessionData,
    simulationAddress
  )
  return {
    checkedInPickupPointId: simulationParams.checkedInPickupPointId,
    isCheckedIn: simulationParams.isCheckedIn,
    priceTables: simulationParams.priceTables,
    shippingData: simulationParams.shippingData,
    allowExternalSellers: usingMultiSeller(),
  }
}

export const getShowTogetherProductsVariables = async (
  productId: string
): Promise<GetShowTogetherProductsInput> => {
  const simulation = await getSimulationsParams()
  return {
    an: getAccountName(),
    sc: getSalesChannel(),
    compSpecs: true,
    productId: productId,
    simulation,
  }
}
